import { defineMessages } from 'react-intl';

export default defineMessages({
    back: {
        id: 'adac.common-modal.Back',
        defaultMessage: 'Back'
    },
    phoneNumber: {
        id: 'adac.common-modal.Phone number',
        defaultMessage: '+4989767676'
    }
});
